/**
 * Query keys do domínio de atendimento (tickets de suporte).
 *
 * `support_tickets` + `support_ticket_messages`. A lista aceita filtros
 * (status, categoria) — eles entram na key para o cache não misturar recortes
 * diferentes quando o operador troca o filtro.
 */
import { tuple } from "./core";

const root = ["support"] as const;

export interface SupportTicketListFilters {
  status?: string | null;
  /** Status marcados (filtro múltiplo do CRM). Vazio = todos. */
  statuses?: readonly string[];
  categoria?: number | null;
  busca?: string;
}

export const support = {
  all: root,
  /** Chamados de um clube (CRM) ou da plataforma inteira quando clubId é null (admin). */
  list: (
    clubId: string | null | undefined,
    filters?: SupportTicketListFilters,
  ) => tuple(root, "list", clubId, filters ?? {}),
  byId: (ticketId: string | null | undefined) =>
    tuple(root, "detail", ticketId),
  /** Thread de mensagens de um chamado. */
  messages: (ticketId: string | null | undefined) =>
    tuple(root, "messages", ticketId),
  /**
   * Anexos de um chamado, já com URL assinada. Separado de `messages` porque
   * a assinatura tem validade e precisa poder expirar sozinha, sem arrastar a
   * thread inteira junto.
   */
  attachments: (ticketId: string | null | undefined) =>
    tuple(root, "attachments", ticketId),
  /** Prazos de SLA por prioridade (`support_sla_policies`). */
  slaPolicies: tuple(root, "sla-policies"),
} as const;
